import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSellers } from '../../actions/sellersActions';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { Spinner } from 'react-bootstrap';
import { fetchExportarOrdenesTelefonicasApi } from '../../api/axios';
import { toast } from 'react-toastify';
import { limpiarFiltros } from '../../actions/generalActios';
import { filtroMedioMes } from '../../utilities/fechasFiltro';
import { exportToExcel } from '../General/Excel/ExcelExportHelper';
const fechaFiltro = filtroMedioMes();

class FiltroOrdenesTelefonicas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaDesde: "",
            fechaHasta: "",
            hideSpinner: true,
            datosExcelFormateados: null
        }
    };

    componentDidMount() {
        this.setState({
            fechaDesde: this.props.filtro.fechaDesde != undefined ? this.props.filtro.fechaDesde : fechaFiltro.desde,
            fechaHasta: this.props.filtro.fechaHasta != undefined ? this.props.filtro.fechaHasta : fechaFiltro.hasta
        });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.setState({
            datosExcelFormateados: null,
            hideSpinner: false
        });

        this.requestParaExportarTelefonicas({
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta
        });
    }

    requestParaExportarTelefonicas = async (request) => {
        let req = null;
        try {
            req = await fetchExportarOrdenesTelefonicasApi(request);
        } catch (e) {
            toast.error('No se pudo descargar el excel');
            return;
        }
        this.ordenarExcelTelefonicas(req);
    }

    ordenarExcelTelefonicas = (ordenesResponse) => {
        let ordenes = ordenesResponse.ordenes
        let listaOrdenes = [];

        for (let index = 0; index < ordenes.length; index++) {
            var item = ordenes[index];
            if (item.idVendedorBoca === 0) continue;

            let idOrdenAnterior;

            let fechaOrden = "";
            if (item.fecha !== null) {
                let fechaSplit = item.fecha.slice(0, 10).split('-');
                fechaOrden = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`;
            }

            item.productos.map((p) => {
                let ordenMultipleProductos = false;

                if (idOrdenAnterior !== undefined) {
                    if (item.idOrden == idOrdenAnterior) {
                        ordenMultipleProductos = true;
                    }
                }

                let montoVenta = this.changeMonto(item.montoVenta);

                let datoOrden = {
                    fecha: fechaOrden,
                    idOrden: item.idOrden,
                    dniCliente: item.cliente.documento !== null ? item.cliente.documento : "",
                    nombreApellidoCliente: (item.cliente.nombre !== null || item.cliente.apellido !== null) ? item.cliente.nombre + " " + item.cliente.apellido : "",
                    estado: item.estado[0].descripcion !== null ? item.estado[0].descripcion : "",
                    montoVenta: ordenMultipleProductos ? "" : montoVenta,
                    producto: p.skuMarket !== null ? p.skuMarket : "",
                    idVendedorBoca: item.idVendedorBoca
                };

                idOrdenAnterior = datoOrden.idOrden;
                listaOrdenes.push(datoOrden);
            })
        }
        this.setState({
            datosExcelFormateados: listaOrdenes,
            hideSpinner: true
        })

        document.getElementById('btnDescargaExcel2').click();
    }

    changeMonto = (num) => {
        if (typeof num === "string") {
            num = new Number(num);
        }

        let formattedNumber = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(num);

        return formattedNumber;
    }

    verTodos = () => {
        this.onSelectSearchInputSellers(null);

        this.setState({
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta
        });

        let params = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta
        }

        this.props.updateRequest(params);
    }


    render() {
        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (
            <div className="card card-body filter-card">

                <div className="row form-material">
                    <div className="col-lg-2">
                        <label className="label-oscura">Fecha desde</label>
                        <input
                            type="date"
                            name="fechaDesde"
                            className="form-control"
                            value={this.state.fechaDesde}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Fecha hasta</label>
                        <input
                            type="date"
                            name="fechaHasta"
                            className="form-control"
                            value={this.state.fechaHasta}
                            onChange={this.myChangeHandler}
                        />
                    </div>
                </div>

                <div className="row p-10">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                        <button
                            className="btn d-inline btn-sm btn-grey m-r-10"
                            onClick={this.onSubmit}
                            type="button"
                            disabled={this.props.loadingOrdenes}
                        >
                            Descargar
                        </button>
                        <button onClick={this.verTodos} className="btn btn-sm btn-grey d-inline">
                            Limpiar
                        </button>
                    </div>
                    <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
                        <Spinner hidden={this.state.hideSpinner || sizeArray == "[]"} style={{ position: "relative", top: "5px", right: "0px", padding: "0px", margin: "0px" }} animation="border" variant="secondary" size="sm-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                </div>

                <button 
                    id="btnDescargaExcel2" 
                    type="button" 
                    hidden={true}
                    onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Ordenes Telefonicas', 'Ordenes Telefonicas')}
                />
            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    sellers: state.sellers.filteredSellers,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    fetchSellers,
    fetchSellersFilter,
    limpiarFiltros
})(FiltroOrdenesTelefonicas);